const ModalBody = props => (
  <div className={`dashboard-modal__body ${props.className && props.className}`}>
    {props.children}
  </div>
)
export default ModalBody
